import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ISearchForm } from 'src/app/_models/search';
import { SearchService } from 'src/app/_services/search.service';
import { CategoryService } from 'src/app/_services/category.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';

import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';

@Component({
  selector: 'app-search-config',
  templateUrl: './search-config.component.html',
  styleUrls: ['./search-config.component.scss']
})

export class SearchConfigComponent implements OnInit {

  allSearchForms: ISearchForm[];
  navBarForms: any[];
  selectedForm: ISearchForm;
  allCategories: any;
  filterValue: string;
  searchFormName: string;
  openForm: boolean = false;
  searchForm: FormGroup;
  successMessage: boolean = false;
  createSearchForm: boolean = false;
  updateSearchForm: boolean = false;
  button: string = "Save"
  selectedFormDisplayList = []
  systemAttrDisplayList = []
  categories: number[]
  listOfOperators = ["=", ">", "<", "<=", ">=", "!=", "Contains", "IN"]
  listOfUIControl: string[] = ['InputText', 'Date', 'Static', 'Dynamic']
  searchCtrl: string
  criteriaQuery: any
  bindingName: string[]
  message: string;
  connectingOperator: string = "AND";
  userGroups: []
  isAdmin: boolean = false
  formColumns=["Search Input", "HelpText/Value", "Operator", "Required", "UI Control", "Attribute"]

  noSearchForms: boolean = false


  constructor(
    private searchSvc: SearchService,
    private categorySvc: CategoryService,
    private authenticationService: AuthenticationService,
    private groupService: UsersAndGroupsService
  ) {
    this.userGroups = this.authenticationService.userGroupsValue;
  }

  ngOnInit() {
    this.getData()
    this.newSearchForm()

    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"));

  }

  getData() {
    this.searchSvc.getSearchForms()
      .subscribe(forms => {


        if(typeof forms == "string"){
          this.noSearchForms = true
        } else {
          this.noSearchForms = false
          this.allSearchForms = forms;
          this.navBarForms = forms
        }

      });
    this.categorySvc.getAll()
      .subscribe(categories => {
        this.allCategories = categories;
      });
  }

  clearData() {
    this.selectedFormDisplayList = []
    this.categories = []
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.navBarForms = []
      this.search()
    }
    else {
      this.navBarForms = this.allSearchForms
    }
  }

  search() {
    this.allSearchForms.filter(form => {
      if ((form.name.trim().toLowerCase().indexOf(this.filterValue.trim().toLowerCase()) > -1)) {
        this.navBarForms.push(form)
      }
    })
  }

  newSearchForm() {
    this.searchForm = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      categories: new FormControl('', Validators.required),
      search_criteria: new FormControl('', Validators.required),
      display_list: new FormControl('', Validators.required),
      form: new FormArray([this.initForm()])
    })
  }

  openNewSearchForm() {
    this.newSearchForm()
    this.openForm = true;
    this.createSearchForm = true;
    this.updateSearchForm = false;
    this.successMessage = false;
    this.button = "Save"
    this.clearData()
  }

  initForm() {
    return new FormGroup({
      label: new FormControl('', Validators.required),
      helpText: new FormControl('', Validators.required),
      operator: new FormControl('', Validators.required),
      required: new FormControl(Boolean, Validators.required),
      UIControl: new FormControl('', Validators.required),
      //bindingName: new FormControl('', Validators.required),
      values: new FormControl(''),
      attribute: new FormControl('', Validators.required)
    })
  }

  addNewForm() {
    const control = <FormArray>this.searchForm.get('form');
    control.push(this.initForm());
  }

  getForm(form) {
    return form.controls.form.controls;
  }

  deleteForm(index: number) {
    this.formArray.removeAt(index);
    this.attributeChangeHandler()
  }

  get formArray() {
    return <FormArray>this.searchForm.get("form")
  }

  getSearchForm(formId) {
    this.createSearchForm = false
    this.updateSearchForm = true
    this.successMessage = false
    this.button = "Update"
    this.clearData()
    this.selectedForm
    var searchForm = this.allSearchForms.find(x => x.id == formId);
    this.selectedForm = Object.assign({}, searchForm)
    this.searchFormName = this.selectedForm.name
    this.openForm = true;
    this.newSearchForm()
    this.categories = this.selectedForm['categories']
    if (this.selectedForm['search_criteria']) {
      this.connectingOperator = Object.keys(JSON.parse(this.selectedForm['search_criteria']))[0]
    }
    this.getDisplayListData(this.selectedForm.categories);
    var data = {
      name: this.selectedForm['name'],
      description: this.selectedForm['description'],
      categories: this.selectedForm['categories'],
      search_criteria: this.selectedForm['search_criteria'],
      display_list: [],
      form: []
    }
    var displayList = []
    var splitDisplayList = (this.selectedForm.display_list.split("[")[1].split("]")[0].split(","))
    splitDisplayList.forEach((element, index) => {
      if (index % 2 == 0) {
        splitDisplayList[index] = splitDisplayList[index] + "," + splitDisplayList[index + 1]
        displayList.push(splitDisplayList[index])
      }
    })
    displayList.forEach(element => {
      data['display_list'].push(element.split(":")[1].split(",")[0].split('"')[1])
    })
    this.selectedForm['form'].forEach((element, index) => {
      this.addNewForm()
      var obj = {}
      if (element['criterion'].includes("meta_data")) {
        element['attribute'] = element['criterion'].split("'")[3].trim()
      }
      obj["label"] = element['label']
      obj["UIControl"] = element['UIControl']
      obj["helpText"] = element['helpText']
      obj["operator"] = element['operator']
      obj["required"] = element['required']
      obj['attribute'] = element['attribute']
      data.form.push(Object.assign({}, obj))
    })
    this.deleteForm(this.selectedForm['form'].length - 1)
    this.searchForm.patchValue(data)
  }

  getDisplayListData(searchFormCategories) {
    this.selectedFormDisplayList = [
      { name: "Title", value: "title" },
      { name: "Creation Date", value: "create_date" },
      { name: "Created By", value: "created_by" },
      { name: "Modified Date", value: "modified_date" },
      { name: "Modified By", value: "modified_by" },
      { name: "Document ID", value: "document_id"},
      { name: "Document Version", value: "version_num"},      
    ]
    for (let category of this.allCategories.results) {
      for (let selectedCategory of searchFormCategories) {
        if (category.id == selectedCategory) {
          for (let metaData of category.meta_data_definition) {
            if (metaData.active) {
              for (let property of metaData.properties) {
                var obj = {}
                if (property.name) {
                  obj["name"] = property.name.trim()
                  obj["value"] = property.name.trim()
                  this.selectedFormDisplayList.push(obj)
                }
              }
            }
          }
        }
      }
    }
    this.systemAttrDisplayList = [
      { name: "File Type", value: "type" },
      { name: "Size", value: "size" },
      { name: "Document Title", value: "fileName"}
    ]
    for (let property of this.systemAttrDisplayList) {
      var obj = {}
      obj["name"] = property.name
      obj["value"] = property.value
      this.selectedFormDisplayList.push(obj)
    }
    this.selectedFormDisplayList = this.removeDuplicateFromDisplayList(this.selectedFormDisplayList, "value")
    this.selectedFormDisplayList = this.sortDisplayList(this.selectedFormDisplayList, "name");
  }

  removeDuplicateFromDisplayList = (array, key) => {
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
  }

  sortDisplayList = (array, key) => {    
    return array.sort((a, b) => {
      return a[key].localeCompare(b[key]);
    });
  }

  attributeChangeHandler() {
    const connectorArray = []
    var search_criteria = {}
    this.searchForm.get("form").value.forEach(formdata => {
      connectorArray.push(formdata.label)
      if (this.connectingOperator == "AND") {
        search_criteria = {
          "AND": connectorArray
        }
      } else {
        search_criteria = {
          "OR": connectorArray
        }
      }
    })

    this.searchForm.patchValue({ search_criteria: JSON.stringify(search_criteria) })
  }

  createSearchFormPayload() {
    var newForm = Object.assign({}, this.searchForm.value)

    newForm['search_criteria'] = JSON.parse(newForm['search_criteria'])
    for (let index = 0; index < newForm.form.length; index++) {
      newForm.form[index].values = newForm.form[index].attribute.toString().toLowerCase().trim()
      if (newForm.form[index].UIControl == "Date") {
        newForm.form[index].values = new Date()
      }

      if (newForm.form[index]['operator'] !== "IN") {
        if (newForm.form[index]['attribute'] == "type" || newForm.form[index]['attribute'] == "size" || newForm.form[index]['attribute'] == "fileName") {
          newForm.form[index]['criterion'] = "meta_data->'system'->>'" + newForm.form[index].attribute + "' " + newForm.form[index].operator + " '?" + (newForm.form[index].attribute).toString().toLowerCase().trim() + "?'"
          if (newForm.form[index]['operator'] == "Contains") {
            newForm.form[index]['criterion'] = "meta_data->'system'->>'" + newForm.form[index].attribute + "' ilike '%?" + (newForm.form[index].attribute).toString().toLowerCase().trim() + "?%'"
          }
          newForm.form[index]['icriterion'] = "meta_data->'system'->>'" + newForm.form[index].attribute + "' ilike '%?" + (newForm.form[index].attribute).toString().toLowerCase().trim() + "?%'"
          newForm.form[index]['bindingName'] = newForm.form[index].attribute.toString().toLowerCase().trim()
        }
  
        else if (newForm.form[index]['attribute'] != "create_date" 
                && newForm.form[index]['attribute'] != "created_by" 
                && newForm.form[index]['attribute'] != "title" 
                && newForm.form[index]['attribute'] != "modified_date"
                && newForm.form[index]['attribute'] != "modified_by"
                && newForm.form[index]['attribute'] != "document_id"
                && newForm.form[index]['attribute'] != "version_num") {
          newForm.form[index]['criterion'] = "meta_data->'properties'->>'" + newForm.form[index].attribute + "' " + newForm.form[index].operator + " '?" + (newForm.form[index].attribute).toString().toLowerCase().trim() + "?'"
          if (newForm.form[index]['operator'] == "Contains") {
            newForm.form[index]['criterion'] = "meta_data->'properties'->>'" + newForm.form[index].attribute + "' ilike '%?" + (newForm.form[index].attribute).toString().toLowerCase().trim() + "?%'"
          }
          newForm.form[index]['icriterion'] = "meta_data->'properties'->>'" + newForm.form[index].attribute + "' ilike '%?" + (newForm.form[index].attribute).toString().toLowerCase().trim() + "?%'"
          newForm.form[index]['bindingName'] = newForm.form[index].attribute.toString().toLowerCase().trim()
        } else {
          switch (newForm.form[index]['attribute']) {
            case "title": 
              newForm.form[index]['criterion'] = "title " + newForm.form[index].operator + " '?documentName?'"
              newForm.form[index]['icriterion'] = "title " + newForm.form[index].operator + " '?documentName?'"            
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "title ilike '%?documentName?%'"
                newForm.form[index]['icriterion'] = "title ilike '%?documentName?%'"
              }
              newForm.form[index]['bindingName'] = "documentName"
              break;
            case "create_date": 
              newForm.form[index]['criterion'] = "create_date " + newForm.form[index].operator + " '?UploadDateFrom?'"
              newForm.form[index]['icriterion'] = "create_date " + newForm.form[index].operator + " '?UploadDateFrom?'"
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "create_date::text like '%?UploadDateFrom?%'"
                newForm.form[index]['icriterion'] = "create_date::text ilike '%?UploadDateFrom?%'"
              }
              newForm.form[index]['bindingName'] = "UploadDateFrom"
              break;
            case "created_by": 
              newForm.form[index]['criterion'] = "created_by " + newForm.form[index].operator + " '?createdBy?'"
              newForm.form[index]['icriterion'] = "created_by " + newForm.form[index].operator + " '?createdBy?'"
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "created_by::text like '%?createdBy?%'"
                newForm.form[index]['icriterion'] = "created_by::text ilike '%?createdBy?%'"
              }
              newForm.form[index]['bindingName'] = "createdBy"
              break;
            case "modified_date": 
              newForm.form[index]['criterion'] = "modified_date " + newForm.form[index].operator + " '?ModifiedDateFrom?'"
              newForm.form[index]['icriterion'] = "modified_date " + newForm.form[index].operator + " '?ModifiedDateFrom?'"
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "modified_date::text like '%?ModifiedDateFrom?%'"
                newForm.form[index]['icriterion'] = "modified_date::text ilike '%?ModifiedDateFrom?%'"
              }
              newForm.form[index]['bindingName'] = "ModifiedDateFrom"
              break;
            case "modified_by": 
              newForm.form[index]['criterion'] = "modified_by " + newForm.form[index].operator + " '?modified_by?'"
              newForm.form[index]['icriterion'] = "modified_by " + newForm.form[index].operator + " '?modified_by?'"
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "modified_by::text like '%?modified_by?%'"
                newForm.form[index]['icriterion'] = "modified_by::text ilike '%?modified_by?%'"
              }
              newForm.form[index]['bindingName'] = "modified_by"
              break;
            case "document_id": 
              newForm.form[index]['criterion'] = "document_id " + newForm.form[index].operator + " '?document_id?'"
              newForm.form[index]['icriterion'] = "document_id " + newForm.form[index].operator + " '?document_id?'"
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "document_id::text like '%?document_id?%'"
                newForm.form[index]['icriterion'] = "document_id::text ilike '%?document_id?%'"
              }
              newForm.form[index]['bindingName'] = "document_id"
              break;
            case "version_num": 
              newForm.form[index]['criterion'] = "version_num " + newForm.form[index].operator + " '?version_num?'"
              newForm.form[index]['icriterion'] = "version_num " + newForm.form[index].operator + " '?version_num?'"
              if (newForm.form[index]['operator'] == "Contains") {
                newForm.form[index]['criterion'] = "version_num::text like '%?version_num?%'"
                newForm.form[index]['icriterion'] = "version_num::text ilike '%?version_num?%'"
              }
              newForm.form[index]['bindingName'] = "version_num"
              break;
          }
        }
      } else {
        let selectedForm = this.allSearchForms.filter(form => form.id == this.selectedForm.id)[0];
        newForm.form[index] = selectedForm.form[index];
      }
      //delete newForm.form[index]['attribute']
      if (newForm.form[index]['required']) {
        newForm.form[index]['required'] = true
      } else {
        newForm.form[index]['required'] = false
      }
    }

    const displayList = []
    newForm.display_list.forEach(element => {
      displayList.push({ "Property Name": element, "Display Name": element })
    });
    newForm.display_list = displayList
    return newForm
  }

  saveSearchForm() {
    const payload = this.createSearchFormPayload()
    this.searchSvc.createSearchForm(payload).subscribe(data => {
      this.message = "<strong>" + payload.name + "</strong> has been saved successfully!"
      this.successMessage = true
      this.createSearchForm = false
      this.updateSearchForm = false
      this.openForm = false
      this.getData()
    })
  }

  updateSearch() {
    const updatedForm = this.createSearchFormPayload()
    updatedForm.formid = this.selectedForm.id
    this.searchSvc.updateSearchForm(updatedForm).subscribe(data => {
      this.message = "<strong>" + updatedForm.name + "</strong> has been updated successfully!"
      this.successMessage = true
      this.createSearchForm = false
      this.updateSearchForm = false
      this.openForm = false
      this.getData()
    },
      error => {

        console.error("Error", error)

      });
  }

  back() {
    this.successMessage = false;
    this.openForm = false;
  }

  deleteSearchFormHandler() {
    this.searchSvc.deleteSearchForm(this.selectedForm.id, this.selectedForm.name).subscribe(resp => {

      console.log("DELETED", this.selectedForm.name)

      this.openForm = false
      this.getData()
    })
  }
}